import React from 'react'
import ImageWrapper from './ImageWrapper'
import { navigate } from 'gatsby'

const PlayStoreButton = ({ MaxWidth }) => {
  
  const redirectPath = () => {
    navigate('https://play.google.com/store/apps/details?id=com.ufaber.ieltsninja')
  }

  return (
    <>
      <button className='play_store_btn' style={{maxWidth: `${MaxWidth}px`}} onClick={redirectPath}>
        <ImageWrapper ImgUrl={"http://s3.us-east-2.wasabisys.com/ufaber-lms/files/419369c608343231de1488a2276ce364.168589139849945"}/>
      </button>
    </>
  )
}

export default PlayStoreButton